import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ComplainLink extends Component {
  render() {
    let newType;

    switch (this.props.ctype) {
      case "site_admin":
        newType = "agent_list";
        break;
      case "sub_admin":
      case "subadmin":
        newType = "agent_list";
        break;
      case "customer_service":
        newType = "agent_list";
        break;
      case "super_admin":
      case "superadmin":
        newType = "sub_admin";
        break;
      case "master_admin":
        newType = "super";//upline
        break;
      case "affiliate":
        newType = "agent_list";
        break;
      default:
        newType = "";
        break;
    }

    return (
      <>
        <Link to={`/complain/${newType.toLowerCase()}/${this.props.url}`} target="_blank" rel="noreferrer">
          অভিযোগ
        </Link>
      </>
    );
  }
}